import { useTranslation } from 'react-i18next';

interface PreviewLinkProps {
  domain: string;
  subdomain: string;
  linkKey: string;
}

export default function PreviewLink({
  domain,
  subdomain,
  linkKey,
}: PreviewLinkProps) {
  const { t } = useTranslation();
  const hasSubdomain = subdomain?.trim().length > 0;
  const hasLinkKey = linkKey?.trim().length > 0;
  return (
    <div className="space-y-2 md:space-y-4">
      <p className="text-base font-semibold text-[#172B4D]">
        {t('links.shortLink')}
      </p>
      <div className="flex flex-col lg:flex-row border border-[#E5E9EB] lg:rounded-[71px] rounded-[24px] gap-2 items-stretch">
        <div className="flex items-center bg-[#F4F4F4] text-[#4D4D4D] text-base rounded-t-[24px] lg:rounded-r-none lg:rounded-l-[49px] p-3 lg:p-5">
          https://
        </div>
        <div className="flex w-full p-2 lg:py-4 gap-2 flex-wrap min-w-0">
          {hasSubdomain && (
            <span className="bg-[#f0f5ff] px-3 py-1 rounded-[49px] text-[#172B4D] text-base break-all">
              {subdomain}
            </span>
          )}
          <span className="bg-[#f0f5ff] px-3 py-1 rounded-[49px] text-[#172B4D] text-base break-all">
            {domain}
          </span>
          {hasLinkKey && (
            <span className="bg-[#f0f5ff] px-3 py-1 rounded-[49px] text-[#172B4D] text-base break-all">
              {linkKey}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
